const e=async(e,t)=>{await e.delete(`/users/${t}/purge`)};export{e as purgeUser};
//# sourceMappingURL=purge-user.mjs.map